import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const CREDIT_ELIGIBILITY_REPORT_URL = `${API_URL}/credit-eligibility-submissions`

export const service = {
  getCreditEligibilityReport: (params: ParamsModel) => {
    return axios.get(CREDIT_ELIGIBILITY_REPORT_URL, {params})
  },
  getCreditEligibilityReportDetail: (id: string) => {
    return axios.get(`${CREDIT_ELIGIBILITY_REPORT_URL}/${id}`)
  },
  updateCreditEligibilityStatus: (id: string, status: string) => {
    return axios.patch(`${CREDIT_ELIGIBILITY_REPORT_URL}/${id}/status`, {status})
  },
}
